import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { StockService } from '../../services/stock.service';
import { FormArray,FormGroup,FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Stock } from '../../model/Stock';
import { LoadService } from '../../services/load.service';
import { LocationService } from '../../services/location.service';

@Component({
  selector: 'salidas',
  templateUrl: './salidas.component.html',
  styleUrls: ['./salidas.component.css']
})
export class SalidasComponent implements OnInit {
  @ViewChild(ModalDirective) lgModal: ModalDirective;
  public load:number;
  public primeracarga:boolean;
  public stock_list:any;
  public alert:string;
  public isopen:boolean;
  public links: any;
  public meta: any;
  public title = '';
  public signupForm: FormGroup;
  public item_to_update:number;
  public settings = {
    columns:{
      created_at: { header: "Fecha de Salida", type:"date",tipo:"inputs_outputs",path:"attributes.created_at" },
      pallet_code: { header: "Pallet", type:"text" },
      total: { header: "Total Cajas", type:"text" },
      location:{header: "Ubicación", type:"obj", filter:{visible:true, id_type:'number', default:'asc', type:'dd'} },
      position:{header: "Posición", type:"text" }
    },
    actions:{
      edit: false,
      view: false,
      delete: false
    }
  };

  constructor(private _stockService:StockService,private _loaddata: LoadService, private _location: LocationService) {
    this.stock_list = [];
    this.primeracarga = false;
  }

  ngOnInit() {
    this._loaddata.loadChange(30);
    this._loaddata.loadCurrent.subscribe(a=> this.load = a);
    this.signupForm = new FormGroup({
      'fecha': new FormControl(null),
    });
    this.getUbicaciones();
    //this.loadData();
  }

  /*carga los datos con respecto a un filtro en particular*/
    loadDataFiltered(filters){
      this.alert = 'Cargando información.'
      this.isopen = true;
      this._loaddata.loadChange(50);
      console.log("filtros desde entradas ", filters);
      this._stockService.getDataFiltered3Outputs(filters).subscribe(
        (response:any) => {
          this.stock_list = response.data;
          this.stock_list = this.formatDate(this.stock_list);
          this.links = response.links;
          this.meta = response.meta;
          this._loaddata.loadChange(100);
          this.alert = "Carga Correcta.";
          this.onClosedAutomatic();
          if(this.primeracarga === false){
            this.primeracarga = !this.primeracarga;
          }
        },
        (error) => {
          if(error.status == 0){
            this.alert = 'Busqueda sin resultados.';
            this.isopen = true;
            this.onClosedAutomatic();
          }
          else{
            this.showError(error.error.error);
          }
        }
      );
    }

  loadData(){
    this.alert = 'Cargando información';
    this.isopen = true;
    this._loaddata.loadChange(60);
    this._stockService.getStockOutputs().subscribe(
      (response:any) => {
        if(this.primeracarga === false){
          this.primeracarga = !this.primeracarga;
        }
        this.stock_list = response.data;
        console.log("Salidas ", response);
        this.stock_list = this.formatDate(this.stock_list);
        console.log("Stock_List ", this.stock_list);
        this.links = response.links;
        this.meta = response.meta;
        this._loaddata.loadChange(100);
        this.alert = 'Información cargada.';
        this.onClosedAutomatic();
      },
      (error:any) => {
        this.showError(error.error.error);
      }
    );
  }

  /*obtiene las ubicaciones para los filtros*/
    getUbicaciones(){
      this.alert = 'Cargando ubicaciones.';
      this.isopen = true;
      this._loaddata.loadChange(60);

      this._location.getAll().subscribe(
        (response:any) => {
          let data = response.data;
          let location:string = "{";
          for (var key in data) {
            if (data.hasOwnProperty(key)) {
              location+='"'+data[key].id+'":"'+data[key].attributes.name+'",';
            }
          }
          location = location.slice(0,-1);
          location+="}";
          this.settings.columns.location.filter['data'] = location;
          this.loadData();
        },
        (error) => {
          this.showError(error.error.error);
        }
      );
    }

  /**
  * Cierra el mensaje de alerta despues de 3 segundos
  */
  onClosed(): void {
      this.isopen = false;
  }

  /**
  * Cierra el mensaje de alerta despues de 3 segundos
  */
  onClosedAutomatic(): void {

      setTimeout(()=>{
      this.isopen = false;
    }, 3000);

  }

  /*formatea la fecha*/
  formatDate(stock_list:any){
    for(let entrada of stock_list){
      let fecha = entrada.attributes.created_at.date;
      let fechArray = fecha.split(' ');
      let fecha2 = fechArray[0];
      let fechArray2 = fecha2.split('-');


      entrada.attributes.created_at = fechArray2[2]+'-'+fechArray2[1]+'-'+fechArray2[0];
    }
    return stock_list;
  }

  updateData(data:any){
    this.stock_list = data;
    this.stock_list = this.formatDate(this.stock_list);
    this.onClosedAutomatic();
  }

/**
 * carga la informacion de una fila en el formulario
 * @param index indice de la fila
 */
  showViewForm(index):void {
    this.showChildModal();
  }

  showChildModal(): void {
    this.lgModal.show();
  }

  hideChildModal(): void {
    this.lgModal.hide();
  }

  handler(type: string, $event: ModalDirective) {
    if (type === 'onHide'){
    }
  }

  showError(msg:string){
    if(msg == undefined){
      this.alert = 'No tiene permisos para realizar la acción.';
    }
    else{
      this.alert = msg;
    }
    this._loaddata.loadChange(100);
    this.isopen =true;
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/salidas/salidas.component.ts